<template>
  <div :id="componentId" class="spm1-address" :style="{ backgroundColor }">
    <div class="spm1-address-image-wrapper">
      <img class="spm1-address-image" referrerpolicy="no-referrer" :src="address.image" />
      <div class="spm1-address-name-bar">
        <span class="spm1-address-name">{{ address.name }}</span>
      </div>
    </div>
    <img class="spm1-map-image" referrerpolicy="no-referrer" :src="address.map" />
  </div>
</template>

<script>
export default {
  name: 'MobileAddressSection',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_8'
    }
  },
  data() {
    return {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      address: {
        name: '北京市朝阳区XXX酒店',
        image: require('../../../special/SpecialOne/assets/img/address_hotel.png'),
        map: require('../../../special/SpecialOne/assets/img/address_map.png')
      }
    }
  }
}
</script>

<style scoped>
.spm1-address {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.spm1-address-image-wrapper {
  position: relative;
  width: 100%;
  margin-bottom: 8px;
  border-radius: 8px;
  overflow: hidden;
}

.spm1-address-image {
  width: 100%;
  height: auto;
  display: block;
}

.spm1-address-name-bar {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 32px;
  background-image: linear-gradient(90deg, rgba(43, 131, 120, 1) 0, rgba(48, 133, 122, 0) 100%);
  display: flex;
  align-items: center;
  padding-left: 12px;
}

.spm1-address-name {
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: Microsoft YaHei-Regular;
  white-space: nowrap;
}

.spm1-map-image {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 8px;
}
</style>
